var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49519_14828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 11.1201C1.2002 9.95073 1.66473 8.82923 2.49161 8.00235C3.31849 7.17547 4.43998 6.71094 5.60937 6.71094C6.49263 6.71094 7.34856 6.97596 8.07086 7.46196",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60937 6.71093C7.23278 6.71093 8.54882 5.39489 8.54882 3.77148C8.54882 2.14807 7.23278 0.832031 5.60937 0.832031C3.98596 0.832031 2.66992 2.14807 2.66992 3.77148C2.66992 5.39489 3.98596 6.71093 5.60937 6.71093Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1402 13.0792C11.7639 13.0792 13.0802 11.7629 13.0802 10.1392C13.0802 8.5155 11.7639 7.19922 10.1402 7.19922C8.51648 7.19922 7.2002 8.5155 7.2002 10.1392C7.2002 11.7629 8.51648 13.0792 10.1402 13.0792Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9209 10.1412L9.73402 10.9544L11.3603 9.32812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49519_14828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsV2);
export default __webpack_public_path__ + "static/media/agentsV2.ef2f1e2d76054d87b7c74139f2be3aba.svg";
export { ForwardRef as ReactComponent };